$(document).ready(function () {
    //////////////////////
	//SHOW CORRECT BUTTONS///
	//////////////////////

	//display subscription or one-time button
	$("#shop .toggle-once").click(function () {
		$(this).parents(".shop-col").find(".toggle-button").removeClass("active");
		$(this).parents(".shop-col").find(".toggle-once").addClass("active");
		$(this).parents(".shop-col").find(".shop-bullets").removeClass("active");
		$(this).parents(".shop-col").find(".shop-bullets-once").addClass("active");
		$(".border-wrapper.once").addClass("active");
        $(".border-wrapper.sub").removeClass("active");
        $(".upsell-buttons-once").addClass("active");
        $(".upsell-buttons-sub").removeClass("active");
        $(".upsell-prices-once").addClass("active");
        $(".upsell-prices-sub").removeClass("active");
	});
	$("#shop .toggle-sub").click(function () {
		$(this).parents(".shop-col").find(".toggle-button").removeClass("active");
		$(this).parents(".shop-col").find(".toggle-sub").addClass("active");
		$(this).parents(".shop-col").find(".shop-bullets").removeClass("active");
		$(this).parents(".shop-col").find(".shop-bullets-sub").addClass("active");
		$(".border-wrapper.once").removeClass("active");
        $(".border-wrapper.sub").addClass("active");
        $(".upsell-buttons-once").removeClass("active");
        $(".upsell-buttons-sub").addClass("active");
        $(".upsell-prices-once").removeClass("active");
        $(".upsell-prices-sub").addClass("active");
	});	

    $(".multipack-selector.one-time.one-pack, .toggle-button.toggle-once").click(function () {
        $(".multipack-selector").removeClass("selected");
        $(".multipack-selector.one-time.one-pack").addClass("selected");
        $(".serving-text, .buy-price.buy-once, .buy-price.buy-sub").removeClass("active");
        $(".serving-text.one-pack, .buy-price.buy-once.one-pack, .buy-price.buy-sub.one-pack").addClass("active");
        $(".buy-button").removeClass("active");
        $(".buy-button.buy-once.one-pack").addClass("active");
        $(".buy-price.buy-sub .strikethrough").hide();
        $(".buy-price.buy-once .strikethrough").show();
        $(".upsell-button").removeClass("active");  
        $(".upsell-button.one-pack").addClass("active");        
        $(".upsell-button").removeClass("active");  
        $(".upsell-button.one-pack").addClass("active");        
        $(".upsell-price").removeClass("active");  
        $(".upsell-price.one-pack").addClass("active");        
    });
    $(".multipack-selector.one-time.two-pack").click(function () {
        $(".multipack-selector").removeClass("selected");
        $(".multipack-selector.one-time.two-pack").addClass("selected");
        $(".serving-text, .buy-price.buy-once, .buy-price.buy-sub").removeClass("active");
        $(".serving-text.two-pack, .buy-price.buy-once.two-pack, .buy-price.buy-sub.two-pack").addClass("active");
        $(".buy-button").removeClass("active");
        $(".buy-button.buy-once.two-pack").addClass("active");
        $(".buy-price.buy-sub .strikethrough").hide();
        $(".buy-price.buy-once .strikethrough").show();
        $(".upsell-button").removeClass("active");  
        $(".upsell-button.two-pack").addClass("active");
        $(".upsell-price").removeClass("active");  
        $(".upsell-price.two-pack").addClass("active");              
    });
    $(".multipack-selector.one-time.three-pack").click(function () {
        $(".multipack-selector").removeClass("selected");
        $(".multipack-selector.one-time.three-pack").addClass("selected");
        $(".serving-text, .buy-price.buy-once, .buy-price.buy-sub").removeClass("active");
        $(".serving-text.three-pack, .buy-price.buy-once.three-pack, .buy-price.buy-sub.three-pack").addClass("active");
        $(".buy-button").removeClass("active");
        $(".buy-button.buy-once.three-pack").addClass("active");
        $(".buy-price.buy-sub .strikethrough").hide();
        $(".buy-price.buy-once .strikethrough").show();
        $(".upsell-button").removeClass("active");  
        $(".upsell-button.three-pack").addClass("active");
        $(".upsell-price").removeClass("active");  
        $(".upsell-price.three-pack").addClass("active");        
    });
    $(".multipack-selector.subscribe.one-pack, .toggle-button.toggle-sub").click(function () {
        $(".multipack-selector").removeClass("selected");
        $(".multipack-selector.subscribe.one-pack").addClass("selected");
        $(".serving-text, .buy-price.buy-sub, .buy-price.buy-once").removeClass("active");
        $(".serving-text.one-pack, .buy-price.buy-sub.one-pack, .buy-price.buy-once.one-pack").addClass("active");
        $(".buy-button").removeClass("active");
        $(".buy-button.buy-sub.one-pack").addClass("active");
        $(".buy-price.buy-sub .strikethrough").show();
        $(".buy-price.buy-once .strikethrough").hide();
        $(".add-beets-once").removeClass("active");
        $(".add-beets-sub").addClass("active");
        $(".upsell-button").removeClass("active");  
        $(".upsell-button.one-pack").addClass("active");
        $(".upsell-price").removeClass("active");  
        $(".upsell-price.one-pack").addClass("active");         
    });
    $(".multipack-selector.subscribe.two-pack").click(function () {
        $(".multipack-selector").removeClass("selected");
        $(".multipack-selector.subscribe.two-pack").addClass("selected");
        $(".serving-text, .buy-price.buy-sub, .buy-price.buy-once").removeClass("active");
        $(".serving-text.two-pack, .buy-price.buy-sub.two-pack, .buy-price.buy-once.two-pack").addClass("active");
        $(".buy-button").removeClass("active");
        $(".buy-button.buy-sub.two-pack").addClass("active");
        $(".buy-price.buy-sub .strikethrough").show();
        $(".buy-price.buy-once .strikethrough").hide();
        $(".add-beets-once").removeClass("active");
        $(".add-beets-sub").addClass("active");
        $(".upsell-button").removeClass("active");  
        $(".upsell-button.two-pack").addClass("active");
        $(".upsell-price").removeClass("active");  
        $(".upsell-price.two-pack").addClass("active");                    
    });
    $(".multipack-selector.subscribe.three-pack").click(function () {
        $(".multipack-selector").removeClass("selected");
        $(".multipack-selector.subscribe.three-pack").addClass("selected");
        $(".serving-text, .buy-price.buy-sub, .buy-price.buy-once").removeClass("active");
        $(".serving-text.three-pack, .buy-price.buy-sub.three-pack, .buy-price.buy-once.three-pack").addClass("active");
        $(".buy-button").removeClass("active");
        $(".buy-button.buy-sub.three-pack").addClass("active");
        $(".buy-price.buy-sub .strikethrough").show();
        $(".buy-price.buy-once .strikethrough").hide();
        $(".add-beets-once").removeClass("active");
        $(".add-beets-sub").addClass("active");
        $(".upsell-button").removeClass("active");  
        $(".upsell-button.three-pack").addClass("active");
        $(".upsell-price").removeClass("active");  
        $(".upsell-price.three-pack").addClass("active");        
    });




    //////////////////////
	//ADD ITEMS TO CART///
	//////////////////////

	//BEETSGUMMIES
	//1 pack sub
	$(".buy-beetsgummies.buy-sub").on("click", function (event) {
		event.preventDefault();
		let formData1PackOnce = {
			'items': [{
				'id': 44344362139901,
				'quantity': 1,
				'selling_plan': 4632805629
			}]
		};
		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData1PackOnce)
		})
			.then(response => {
				return response.json();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	});

	//1 pack once
	$(".buy-beetsgummies.buy-once").on("click", function (event) {
		event.preventDefault();
		let formData1PackOnce = {
			'items': [{
				'id': 44344362139901,
				'quantity': 1
			}]
		};
		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData1PackOnce)
		})
			.then(response => {
				return response.json();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	});

  
	//BEETS
	//1 pack sub
	$(".buy-beets.buy-sub").on("click", function (event) {
		event.preventDefault();
		let formData1PackOnce = {
			'items': [{
				'id': 43198539694333,
				'quantity': 1,
				'selling_plan': 3188556029
			}]
		};
		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData1PackOnce)
		})
			.then(response => {
				return response.json();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	});

	//1 pack once
	$(".buy-beets.buy-once").on("click", function (event) {
		event.preventDefault();
		let formData1PackOnce = {
			'items': [{
				'id': 43198539694333,
				'quantity': 1
			}]
		};
		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData1PackOnce)
		})
			.then(response => {
				return response.json();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	});


	//BEETS
	//2 pack sub
	$(".buy-beets.buy-sub-2pack").on("click", function (event) {
		event.preventDefault();
		let formData1PackOnce = {
			'items': [{
				'id': 44090682179837,
				'quantity': 1,
				'selling_plan': 3930194173
			}]
		};
		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData1PackOnce)
		})
			.then(response => {
				return response.json();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	});

	//2 pack once
	$(".buy-beets.buy-once-2pack").on("click", function (event) {
		event.preventDefault();
		let formData1PackOnce = {
			'items': [{
				'id': 44090682179837,
				'quantity': 1
			}]
		};
		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData1PackOnce)
		})
			.then(response => {
				return response.json();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	});
  

	//BEETS
	//3 pack sub
	$(".buy-beets.buy-sub-3pack").on("click", function (event) {
		event.preventDefault();
		let formData1PackOnce = {
			'items': [{
				'id': 44090682441981,
				'quantity': 1,
				'selling_plan': 3930226941
			}]
		};
		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData1PackOnce)
		})
			.then(response => {
				return response.json();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	});

	//3 pack once
	$(".buy-beets.buy-once-3pack").on("click", function (event) {
		event.preventDefault();
		let formData1PackOnce = {
			'items': [{
				'id': 44090682441981,
				'quantity': 1
			}]
		};
		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData1PackOnce)
		})
			.then(response => {
				return response.json();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	});
  
	//NOURISH
	//1 pack sub
	$(".buy-nourish.buy-sub.one-pack").on("click", function (event) {
		event.preventDefault();
		let formData1PackOnce = {
			'items': [
				{
				'id': 42775101964541,
				'quantity': 1,
				'selling_plan': 3188457725
				}		
			]
		};
		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData1PackOnce)
		})
			.then(response => {
				return response.json();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	});

	//1 pack once
	$(".buy-nourish.buy-once.one-pack, #add-nourish-once1").on("click", function (event) {
		event.preventDefault();
		let formData1PackOnce = {
			'items': [{
				'id': 42775101964541,
				'quantity': 1
			}]
		};
		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData1PackOnce)
		})
			.then(response => {
				return response.json();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	});

	//2 pack sub
	$(".buy-nourish.buy-sub.two-pack").on("click", function (event) {
		console.log("miami");
		event.preventDefault();
		let formData1PackOnce = {
			'items': [
				{
				'id': 42775102554365,
				'quantity': 1,
				'selling_plan': 3188490493
				}
			]
		};
		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData1PackOnce)
		})
			.then(response => {
				return response.json();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	});

	//2 pack once
	$(".buy-nourish.buy-once.two-pack").on("click", function (event) {
		event.preventDefault();
		let formData2PackOnce = {
			'items': [{
				'id': 42775102554365,
				'quantity': 1
			}]
		};
		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData2PackOnce)
		})
			.then(response => {
				return response.json();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	});


	//3 pack sub
	$(".buy-nourish.buy-sub.three-pack").on("click", function (event) {
		event.preventDefault();
		let formData1PackOnce = {
			'items': [
				{
				'id': 42775103045885,
				'quantity': 1,
				'selling_plan': 3188523261
				}
			]
		};
		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData1PackOnce)
		})
			.then(response => {
				return response.json();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	});

	//3 pack once
	$(".buy-nourish.buy-once.three-pack").on("click", function (event) {
		event.preventDefault();
		let formData3PackOnce = {
			'items': [{
				'id': 42775103045885,
				'quantity': 1
			}]
		};
		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData3PackOnce)
		})
			.then(response => {
				return response.json();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	});


	//1 pack sub ALT
	$(".buy-nourish-alt.buy-sub.one-pack").on("click", function (event) {
		event.preventDefault();
		let formData1PackOnce = {
			'items': [{
				'id': 42472942403837, 
				'quantity': 1,
				'selling_plan': 3029860605
			}]
		};
		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData1PackOnce)
		})
			.then(response => {
				return response.json();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	});

	//1 pack once ALT
	$(".buy-nourish-alt.buy-once.one-pack").on("click", function (event) {
		event.preventDefault();
		let formData1PackOnce = {
			'items': [{
				'id': 42472942403837,
				'quantity': 1
			}]
		};
		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData1PackOnce)
		})
			.then(response => {
				return response.json();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	});

	//2 pack sub ALT
	$(".buy-nourish-alt.buy-sub.two-pack").on("click", function (event) {
		event.preventDefault();
		let formData1PackOnce = {
			'items': [{
				'id': 42472943943933,
				'quantity': 1,
				'selling_plan': 3029893373
			}]
		};
		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData1PackOnce)
		})
			.then(response => {
				return response.json();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	});

	//2 pack once ALT
	$(".buy-nourish-alt.buy-once.two-pack").on("click", function (event) {
		event.preventDefault();
		let formData2PackOnce = {
			'items': [{
				'id': 42472943943933,
				'quantity': 1
			}]
		};
		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData2PackOnce)
		})
			.then(response => {
				return response.json();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	});


	//3 pack sub ALT
	$(".buy-nourish-alt.buy-sub.three-pack").on("click", function (event) {
		event.preventDefault();
		let formData1PackOnce = {
			'items': [{
				'id': 42472944337149,
				'quantity': 1,
				'selling_plan': 3029926141				
			}]
		};
		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData1PackOnce)
		})
			.then(response => {
				return response.json();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	});

	//3 pack once ALT
	$(".buy-nourish-alt.buy-once.three-pack").on("click", function (event) {
		event.preventDefault();
		let formData3PackOnce = {
			'items': [{
				'id': 42472944337149,
				'quantity': 1
			}]
		};
		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData3PackOnce)
		})
			.then(response => {
				return response.json();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	});

    //BUNDLE
  	//1 bundle once
	  $(".buy-bundle.buy-once.one-pack").on("click", function (event) {
		event.preventDefault();
		let formData1BundleOnce = {
			'items': [{
				'id': 43559915684093,
				'quantity': 1
			}]
		};
		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData1BundleOnce)
		})
			.then(response => {
				return response.json();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	});

	//1 bundle sub
	$(".buy-bundle.buy-sub.one-pack").on("click", function (event) {
		event.preventDefault();
		let formData1BundleSub = {
			'items': [{
				'id': 43559915684093,
				'quantity': 1,
				'selling_plan': 3231088893
			}]
		};
		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData1BundleSub)
		})
			.then(response => {
				return response.json();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	});


	//2 bundle once
	$(".buy-bundle.buy-once.two-pack").on("click", function (event) {
		event.preventDefault();
		let formData2BundleOnce = {
			'items': [{
				'id': 43559915913469,
				'quantity': 1
			}]
		};
		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData2BundleOnce)
		})
			.then(response => {
				return response.json();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	});

    //2 bundle sub
    $(".buy-bundle.buy-sub.two-pack").on("click", function (event) {
    	event.preventDefault();
    	let formData2BundleSub = {
    		'items': [{
    			'id': 43559915913469,
    			'quantity': 1,
    			'selling_plan': 3231023357
    		}]
    	};
    	fetch('/cart/add.js', {
    		method: 'POST',
    		headers: {
    			'Content-Type': 'application/json'
    		},
    		body: JSON.stringify(formData2BundleSub)
    	})
    		.then(response => {
    			return response.json();
    		})
    		.catch((error) => {
    			console.error('Error:', error);
    		});
    });	
  
    //3 bundle once
    $(".buy-bundle.buy-once.three-pack").on("click", function (event) {
	event.preventDefault();
	let formData3BundleOnce = {
		'items': [{
			'id': 43559915946237,
			'quantity': 1
		}]
	};
	fetch('/cart/add.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(formData3BundleOnce)
	})
		.then(response => {
			return response.json();
		})
		.catch((error) => {
			console.error('Error:', error);
		});
    });
    
    //3 bundle sub
    $(".buy-bundle.buy-sub.three-pack").on("click", function (event) {
    event.preventDefault();
    let formData3BundleSub = {
    	'items': [{
    		'id': 43559915946237,
    		'quantity': 1,
    		'selling_plan': 3231056125
    	}]
    };
    fetch('/cart/add.js', {
    	method: 'POST',
    	headers: {
    		'Content-Type': 'application/json'
    	},
    	body: JSON.stringify(formData3BundleSub)
    })
    	.then(response => {
    		return response.json();
    	})
    	.catch((error) => {
    		console.error('Error:', error);
    	});
    });	

  
  
	//20 servings sub
	$("#shop.nourish.servings-20 a.buy-sub.servings-20").on("click", function (event) {
		event.preventDefault();
		let formData20ServingsSub = {
			'items': [{
				'id': 43128233230589,
				'quantity': 1,
				'selling_plan': 3117121789
			}]
		};
		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData20ServingsSub)
		})
			.then(response => {
				return response.json();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	});


	//20 servings once
	$("#shop.nourish.servings-20 a.buy-once.servings-20").on("click", function (event) {
		event.preventDefault();
		let formData20ServingsOnce = {
			'items': [{
				'id': 43128233230589,
				'quantity': 1
			}]
		};
		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData20ServingsOnce)
		})
			.then(response => {
				return response.json();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	});

});